import ImageGallery from "../ImageGallery";
import React from "react";
import {API_ORIGIN} from "../../services/API";

interface VehicleHireDocketGalleryProps {
    vehicleHire: CustomerAPIVehicleHire
    hidden: boolean
}

const VehicleHireDocketGallery = ({
    vehicleHire,
    hidden
}: VehicleHireDocketGalleryProps ) => {

    const { dockets } = vehicleHire;

    if (dockets.length < 1 || hidden) {
        return null;
    }

    return (
        <div>
            <h5>Dockets</h5>

            <ImageGallery
                images={dockets.map(docket => ({
                    src: `${API_ORIGIN}/customer/v1/vehicle-hires/${vehicleHire.id}/dockets/${docket.id}`,
                    title: `Net: ${docket.netQuantity}`,
                    description: docket.comments || " "
                }))}
            />

        </div>
    )

}


export default VehicleHireDocketGallery;
